/* eslint-disable  */
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Table, Container } from 'semantic-ui-react';
import Dayjs from 'dayjs';
import orderBy from 'lodash/orderBy';
import Dimmer from '+/Dimmer';
import VancancyTable from './VacancyTable';
import usePrint from '+/hooks/usePrint';
import logo from '../../logo.png';
import { actions as unitActions } from './sagaSlice';
import { actions as unitTypeActions } from '../_unit-types/sagaSlice';
import { isNumeric } from 'voca';
import { useProperty } from '~/properties';
import { PrintDate } from '+/components/PrintDate';


const ColoredHeader = props => (
    <Table.HeaderCell style={{ backgroundColor: '#bed6ec' }} {...props} />
);

const styles = {
    containerReport: {
        padding: '10px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    logoWrapper: {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)'
    },
    logo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 200
    },
    timeStamp: {
        display: 'flex',
        alignItems: 'flex-end',
        padding: '0 60px'
    }
};

const UnitList = props => {
    const {
        match,
        isFetching,
        fetchPricing,
        pricing,
        readAllUnitTypes,
        unitTypes,
        isFetchingUnitsData
    } = props;

    const { property_id } = match.params;
    const { ref, Trigger } = usePrint();
    const { data: property } = useProperty(property_id);

    useEffect(() => {
        fetchPricing(property_id);
        readAllUnitTypes(property_id);
    }, [property_id, fetchPricing, readAllUnitTypes]);


    const parsedData = useMemo(() => {
        const amenitiesOrdered = pricing.map(i => {
            const order = [...amenityOrder];
            let split = i.amenities.split(',').map(i => i.trim());

            const sorted = order.filter(amenity => {
                if (split.indexOf(amenity) > -1) {
                    split.splice(split.indexOf(amenity), 1);

                    return true;
                }

                return false;
            });

            split = split.filter(amenity => !amenity.toLowerCase().includes('bld') && !amenity.toLowerCase().includes('view'));

            return {
                ...i,
                amenities: sorted.concat(split).join(', ')
            };
        });

        const getBedroomCount = (unit_type) => {

            const bedroom = sea_view_mappings.hasOwnProperty(unit_type) ? sea_view_mappings[unit_type] : unit_type[0];

            return bedroom
        }


        const availableUnits = (amenitiesOrdered || [])
            .filter(i => {
                if (i.Availability) {
                    if (/vacant/i.test(i.Availability)) {
                        return true;
                    }

                    return false;
                }

                return i.days_vacant > 0;
            }).map(i => ({
                ...i,
                bedroom: getBedroomCount(i.unit_type),
                move_out: Date.parse(i.move_out)
            }));

        const unAvailableUnits = (amenitiesOrdered || [])
            .filter(i => {

                if (i.Availability) {
                    if (!/vacant/i.test(i.Availability)) {
                        return true;
                    }

                    return false;
                }

                return i.days_vacant === 0;
            })
            .map(i => ({
                ...i,
                bedroom: getBedroomCount(i.unit_type),
                move_out: Date.parse(i.move_out)
            }));


        const sortedAvailable = orderBy(availableUnits, ['bedroom', 'unit']);
        const sortedAvailableByType = []
            .concat(sortedAvailable.filter(i => !isNumeric(i.bedroom)))
            .concat(sortedAvailable.filter(i => isNumeric(i.bedroom)));

        sortedAvailableByType.unshift({
            stubRow: true,
            stubText: 'Vacant'
        });

        const sortedUnavailable = orderBy(unAvailableUnits, [
            'bedroom',
            'move_out'
        ]);
        const sortedUnavailableByType = []
            .concat(sortedUnavailable.filter(i => !isNumeric(i.bedroom)))
            .concat(sortedUnavailable.filter(i => isNumeric(i.bedroom)));

        sortedUnavailableByType.unshift({
            stubRow: true,
            stubText: 'On Notice'
        });

        return sortedAvailableByType.concat(sortedUnavailableByType);
    }, [pricing]);

    if (isFetching || isFetchingUnitsData || !pricing || !property) return <Dimmer message='Fetching matrix, this can take up to 30 seconds'/>;

    const growth_rate_not_configured = parsedData.filter(unit => unit.growth_rate_not_configured).length;

    return (
        <Container fluid className='overflow-x' style={styles.containerReport}>
            <Trigger />
            <div style={{ position: 'relative' }} className='print landscape' ref={ref}>
                <div style={styles.header}>
                    <VancancyTable units={pricing} unitTypes={unitTypes} />
                    <div style={styles.logoWrapper}>
                        <div style={styles.logo}>
                            <img src={logo} alt='logo' width='100' height='87.5' />
                            {property.name}
                        </div>
                    </div>

                    <div style={styles.timeStamp}>
                        Last Updated: {Dayjs().format('MMM D, YYYY')}
                    </div>
                </div>

                <div>
                    <PrintDate isForPDF={false} />
                </div>
                <br></br>
                {growth_rate_not_configured
                    ? (
                        <div style={{ display: 'flex' }}>
                            <LegendColor color='red' parsedData={parsedData} /> &nbsp;Unit-Types have no registered GR
                        </div>
                    )
                    : <></> }
                <Table compact className='print-font'>
                    <Table.Header>
                        <Header />
                    </Table.Header>


                    <Table.Body>
                        <Body parsedData={parsedData}/>
                    </Table.Body>
                </Table>
            </div>
        </Container>
    );
};


const LegendColor = props => {

    const { color } = props;

    return (
        <div style={{
            width: '12px',
            height: '12px',
            margin: '1.5px',
            marginTop: 4,
            backgroundColor: color
        }}></div>
    );
};

const Body = props => {

    const { parsedData } = props;

    const typesAvail = {
        1: '1 bdm',
        2: '2 bdm',
        3: '3 bdm',
        s: 'Eff/Stu'
    };

    const typesUnavail = {
        1: '1 bdm',
        2: '2 bdm',
        3: '3 bdm',
        s: 'Eff/Stu'
    };

    const unitType = (unit_type, available) => {

        let sea_view_mappings = { 
            'Model S 2':  0,
            'Model S 3':  0,
            'Model S 4':  0,
            'Model SL 1':  0,
            'Model SL 2':  0,
            'Model SL 3':  0,
            'Model SL1 1':  0,
            'Model SL1 2':  0,
            'Model SS':  0,
            'Model S 1':  0,
            'Model SB 1':  0,
            'Model SB 2':  0,
            'Model S2L':  0,
            'Model SWB':  0,
            'Model SSB':  0,
            'Model ALB':  1,
            'Model AT 1':  1,
            'Model AT 2':  1,
            'Model AKT 1':  1,
            'Model AKT 2':  1,
            'Model AKT 3':  1,
            'Model ABB':  1,
            'Model A 1':  1,
            'Model A 2':  1,
            'Model AGT':  1,
            'Model AC':  1,
            'Model BX':  2,
            'Model BRT 2':  2,
            'Model BRT 1':  2,
            'Model BS':  2,
            'Model BB3':  2,
            'Model B5':  2,
            'Model BRC':  2,
            'Model BBW':  2,
            'Model BL':  2,
            'Model BD':  2,
            'Model C2 1':  3,
            'Model C2 2':  3,
            'Model C3 1':  3,
            'Model C3 2':  3,
            'Model C4':  3,
            'Model C1':  3
            }

            const bedroom = sea_view_mappings[unit_type];

            console.log(unit_type)
            console.log(bedroom)

        if (available) {

            if (bedroom){
                const res = typesAvail[bedroom];
                delete typesAvail[bedroom];

                return <b>{res}</b>;
                
            }
            if (typesAvail[unit_type[0]]) {
                const res = typesAvail[unit_type[0]];
                delete typesAvail[unit_type[0]];

                return <b>{res}</b>;
            }

            if (!isNumeric(unit_type[0]) && typesAvail['s']) {
                const res = typesAvail['s'];
                delete typesAvail['s'];

                return <b>{res}</b>;
            }
        }
        else {

            if (bedroom){
                const res = typesUnavail[bedroom];
                delete typesUnavail[bedroom];

                return <b>{res}</b>;
                
            }
            if (typesUnavail[unit_type[0]]) {
                const res = typesUnavail[unit_type[0]];
                delete typesUnavail[unit_type[0]];

                return <b>{res}</b>;
            }

            if (!isNumeric(unit_type[0]) && typesUnavail['s']) {
                const res = typesUnavail['s'];
                delete typesUnavail['s'];

                return <b>{res}</b>;
            }
        }
    };


    return (
        parsedData.map((unit, i) => {

            let style_growth_rate_not_configured = {};
            if (unit.growth_rate_not_configured){
                style_growth_rate_not_configured = {
                    backgroundColor: 'red',
                    color: 'white'
                };
            }

            if (unit.stubRow) {
                return (
                    <Table.Row key={`pricing-${i}`} >
                        <Table.Cell
                            colSpan='50'
                            style={{
                                padding: 1,
                                paddingLeft: '9px',
                                backgroundColor: '#d9e1f1'
                            }}
                        >
                            {unit.stubText}
                        </Table.Cell>
                    </Table.Row>
                );
            }

            return (
                <Table.Row key={`pricing-${i}`} style={style_growth_rate_not_configured}>
                    <Table.Cell
                        content={unitType(unit.unit_type, unit.days_vacant)}

                    />
                    <Table.Cell
                        content={
                            unit.days_vacant
                                ? 'Available'
                                : Dayjs(unit.move_out).format('MM/DD/YYYY')
                        }
                    />
                    <Table.Cell singleLine content={unit.unit} />
                    <Table.Cell
                        textAlign='center'
                        content={
                            unit.days_vacant
                                ? (
                                    <strong>{unit.days_vacant}</strong>
                                )
                                : (
                                    ''
                                )
                        }
                    />
                    <Table.Cell
                        singleLine
                        textAlign='center'
                        content={unit.unit_type}
                    />
                    <Table.Cell width={7} content={unit.amenities} />
                    {priceMapper(unit.prices)}
                </Table.Row>
            );
        })
    );
};

const Header = () => (
    <Table.Row>
        <ColoredHeader />
        <ColoredHeader collapsing content='Available' />
        <ColoredHeader collapsing content='Unit' />
        <ColoredHeader collapsing content='Days Vac' />
        <ColoredHeader collapsing content='Type' />
        <ColoredHeader content='Amenities' />
        <ColoredHeader textAlign='center' content='7' />
        <ColoredHeader textAlign='center' content='8' />
        <ColoredHeader textAlign='center' content='9' />
        <ColoredHeader textAlign='center' content='10' />
        <ColoredHeader textAlign='center' content='11' />
        <ColoredHeader textAlign='center' content='12' />
        <ColoredHeader textAlign='center' content='13' />
        <ColoredHeader textAlign='center' content='14' />
        <ColoredHeader textAlign='center' content='18' />
    </Table.Row>
);

const priceMapper = prices => {
    const lowestPrice = Math.min(...prices);
    // const secondLowestPrice = [...prices].sort((a, b) => a - b)[1];
    // const targetRate = lowestPrice

    return prices.map((price, i) => {
        let style = {};

        if (Number(price) === Number(lowestPrice)) {
            style = {
                backgroundColor: '#66e952',
                color: 'white'
            };
        }

        return (
            <Table.Cell style={style} key={`parsedPrice-${i}`}>
                {price}
            </Table.Cell>
        );
    });
};

const amenityOrder = [
    'Kitchen and Bathroom Upgrade',
    'Studio Kitchen & Bath Upgrade',
    'Stainless Steel Appliances',
    'Dishwasher',
    'Washer and Dryer',
    'Living Room WPC Tile',
    'Living Room Tile',
    'Living Room Porcelain Tile',
    'Master Bedroom WPC Tile',
    'Master Bedroom Tile',
    'Master Bedroom Porcelain Tile',
    '2nd Bedroom WPC Tile',
    '2nd Bedroom Porcelain Tile',
    '2nd Bedroom Tile',
    '3rd Bedroom WPC Tile',
    '3rd Bedroom Tile',
    '3rd Bedroom Porcelain Tile',
    'Bathroom Upgrade - Master Bath',
    'Bathroom Upgrade - 2nd Bath',
    'Bathroom Upgrade in 1 Bedroom',
    'View -Water',
    'View- Water',
    'Floor Premium 5',
    'View - Pool',
    'Floor Premium 1'
];

const mapStateToProps = (state, ownProps) => ({
    isFetching: state.units.isFetching,
    isFetchingUnitsData: state['unit-types'].isFetching,
    pricing: Object.values(state.units.pricing),
    unitTypes: Object.values(state['unit-types'].data)
});

const actions = {
    ...unitActions,
    readAllUnitTypes: unitTypeActions.readAll
};


let sea_view_mappings = { 
    'Model S 2':  0,
    'Model S 3':  0,
    'Model S 4':  0,
    'Model SL 1':  0,
    'Model SL 2':  0,
    'Model SL 3':  0,
    'Model SL1 1':  0,
    'Model SL1 2':  0,
    'Model SS':  0,
    'Model S 1':  0,
    'Model SB 1':  0,
    'Model SB 2':  0,
    'Model S2L':  0,
    'Model SWB':  0,
    'Model SSB':  0,
    'Model ALB':  1,
    'Model AT 1':  1,
    'Model AT 2':  1,
    'Model AKT 1':  1,
    'Model AKT 2':  1,
    'Model AKT 3':  1,
    'Model ABB':  1,
    'Model A 1':  1,
    'Model A 2':  1,
    'Model AGT':  1,
    'Model AC':  1,
    'Model BX':  2,
    'Model BRT 2':  2,
    'Model BRT 1':  2,
    'Model BS':  2,
    'Model BB3':  2,
    'Model B5':  2,
    'Model BRC':  2,
    'Model BBW':  2,
    'Model BL':  2,
    'Model BD':  2,
    'Model C2 1':  3,
    'Model C2 2':  3,
    'Model C3 1':  3,
    'Model C3 2':  3,
    'Model C4':  3,
    'Model C1':  3
    }

export default connect(mapStateToProps, actions)(UnitList);
